import UserService from '../../../services/UserService';

export default {
    namespaced: true,
    state: () => ({
        groupsList: '',
        userRolesList: '',
        loadingStatus: false,
    }),
    getters: {
        getUserGroupsList: state => state.groupsList,
        getUserRolesList: state => state.userRolesList,
    },
    mutations: {
        setUserGroups: (state, userGroups) => {
            state.groupsList = userGroups
        },
        setUserRolesList: (state, userRoles) => {
            state.userRolesList = userRoles
        },
        setLoadingStatus(state, value) {
            state.loadingStatus = value;
        }
    },
    actions: {
        addNewGroup: ({dispatch, commit}, group) => {
            return new Promise((resolve, reject) => {
                commit('setLoadingStatus', true);
                UserService.addNewGroup(group).then(res => {
                    dispatch('getUserGroups')
                    commit('setLoadingStatus', false);
                    resolve(res)
                }).catch((err) => {
                    commit('setLoadingStatus', false);
                    reject(err)
                })
            })
        },
        editUserGroup: ({dispatch, commit}, group) => {
            return new Promise((resolve, reject) => {
                commit('setLoadingStatus', true);
                UserService.editUserGroup(group).then(res => {
                    console.log(res);
                    dispatch('getUserGroups')
                    commit('setLoadingStatus', false);
                    resolve(res)
                }).catch((err) => {
                    commit('setLoadingStatus', false);
                    reject(err)
                })
            })
        },
        getGroupDetail: ({dispatch},groupSysName) => {
            return new Promise((resolve, reject) => {
                UserService.getGroupDetail(groupSysName).then(res => {
                    console.log(res);
                    dispatch('getUserGroups')
                    resolve(res)
                }).catch((err) => {
                    reject(err)
                })
            })
        },
        deleteUserGroup: ({dispatch}, groupSysName) => {
            return new Promise((resolve, reject) => {
                UserService.deleteUserGroup(groupSysName).then(res => {
                    dispatch('getUserGroups')
                    resolve(res)
                }).catch((err) => {
                    reject(err)
                })
            })
        },
        getUserGroups: ({commit}) => {
        return new Promise((resolve, reject) => {
           UserService.userGroups().then(res => {
            //    console.log(res);
                commit('setUserGroups', res.data)
                resolve(res)
           }).catch((err) => {
               reject(err)
           })
        })
       },
    //    getUserRolesList: ({commit}) => {
    //     return new Promise((resolve, reject) => {
    //         UserService.userRolesList().then(res => {
    //              commit('setUserRolesList', res.data)
    //              resolve(res)
    //         }).catch((err) => {
    //             reject(err)
    //         })
    //      })
    //    }
    },
}